export const affiliatePartnerJson = {
    Affiliate_Partner_Id: '',
    Affiliate_Partner: '',
    Created_By: '',
    Created_On: '',
    Modified_By: '',
    Modified_On: '',
    Active: '',
    Country_Id: '0',
    AffiliatePartner_Address: '',
    Contact_Person: '',
    Contact_Number: '0',
    Contact_Email: '',
    Commision_Percentage: '0',
    Commision_Including_GST: '0',
    Bonus: '',
    Attachment_Name: ''
}